export default __webpack_public_path__ + "static/duplicate-as-static-cohort-light-mode-076e09c805f5a4cf14cf543232bed698.png";